import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { activeBusinessFiltersState, dataViewFieldsConfiguration } from '@keepeek/commons';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { useColumnsResolver } from './utils.js';
import ListDataView from './index.js';

var ListDataViewSearchWrapper = function ListDataViewSearchWrapper(_a) {
    var _b;
    var KIcon = _a.KIcon, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, sentryCallback = _a.sentryCallback, allowNavigation = _a.allowNavigation, allowSelection = _a.allowSelection, dataViewKey = _a.dataViewKey, attachmentsVisible = _a.attachmentsVisible, props = __rest(_a, ["KIcon", "shareTokenDownloadAuthorized", "sentryCallback", "allowNavigation", "allowSelection", "dataViewKey", "attachmentsVisible"]);
    var t = useTranslation("refront-components").t;
    var filters = useRecoilValue(activeBusinessFiltersState(dataViewKey));
    var listViewFields = ((_b = useRecoilValue(dataViewFieldsConfiguration)) !== null && _b !== void 0 ? _b : {
        listViewFields: undefined
    }).listViewFields;
    var listViewFieldsWithDefault = listViewFields;
    if (listViewFieldsWithDefault && listViewFieldsWithDefault["default"] === undefined) {
        listViewFieldsWithDefault = {
            "default": ["id", "title"]
        };
    }
    var columns = useColumnsResolver({
        KIcon: KIcon,
        shareTokenDownloadAuthorized: shareTokenDownloadAuthorized,
        sentryCallback: sentryCallback,
        listViewFields: listViewFieldsWithDefault,
        allowNavigation: allowNavigation,
        allowSelection: allowSelection,
        dataViewKey: dataViewKey
    });
    return (React__default.createElement(ListDataView, __assign({ dataViewKey: dataViewKey, filters: filters, columns: columns, KIcon: KIcon, sentryCallback: sentryCallback, shareTokenDownloadAuthorized: shareTokenDownloadAuthorized, attachmentsVisible: attachmentsVisible, title: t("components.dataview.list.table.title"), summary: t("components.dataview.list.table.summary") }, props)));
};

export { ListDataViewSearchWrapper as default };
//# sourceMappingURL=ListDataViewSearchWrapper.js.map
